import {  AddBoxOutlined, } from '@mui/icons-material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import FolderIcon from '@mui/icons-material/Folder';
import { useState } from 'react';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';

import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/src/scss/react-checkbox-tree.scss'


const nodes = [{
    value: 'mars',
    label: 'Mars',
    children: [
        { value: 'phobos', label: 'Phobos' },
        { value: 'deimos', label: 'Deimos' },
    ],
}];
interface iChoice {value:string,label:string}
interface iNode {
    value:string,
    label:string,
    children: iChoice []
}
interface iProps {
    nodes:iNode[],
    checked:string[],
    setChecked:Function,
    disabled?:boolean

 
}
export default function 
TreeSelect ({nodes,checked,setChecked,disabled=false}:iProps){
    
  
    const [expanded, setExpanded] = useState<string[]>([]);
  
    const onCheck = (checked:string[]) => {
      setChecked(checked);
    };
  
    const onExpand = (expanded:string[]) => {
      setExpanded(expanded);
    };
  


        return (
            <CheckboxTree
                nodes={nodes}
                checked={checked}
                expanded={expanded}
                onCheck={onCheck}
                disabled={disabled}
                
                onExpand={onExpand}
                icons={{
                    check: <CheckBoxIcon />,
                    uncheck:<CheckBoxOutlineBlankOutlinedIcon />,
                    expandClose: <AddBoxOutlined/>,
                    expandOpen:<IndeterminateCheckBoxOutlinedIcon />,
                  collapseAll:null,
                    parentClose: null,
                    parentOpen: null,
                    expandAll:null, 
                    leaf:<FolderIcon sx={{color:"var(--primary-color)"}} />,
                    halfCheck:<CheckBoxOutlinedIcon />

                 
                }}
                
                
            
            />
        );
    
}

